module.exports = __webpack_public_path__ + "images/gadget/ui-icons_454545_256x240.png";